import type { Page } from '../../common/page/page.model';
import type { User } from './user.interface';

export interface Comment {
  id: string | null;
  user: User | null;
  textContent: string;
  userLiked: boolean;
  /** moderators and admins only: the commenter is shadow-banned, so no other fan sees this */
  shadowBanned?: boolean;
  state: CommentState;
  createdAt: Date;

  hasChildren: boolean;
  children?: Page<Comment> | null;
}

export enum CommentState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
